import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Role } from '../contracts/role.interface';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private API_URL = 'roles/';

  constructor(private http: HttpClient) {}

  getAll(): Observable<Role[]> {
    return this.http.get<Role[]>(this.API_URL);
  }
}
